import { initSwiper } from 'js/shared/swiper'

const DESKTOP_MIN = 1025

function countSlides(container) {
  return [...container.children].filter((node) => node.nodeType === 1).length
}

function syncPagination(swiper, slideCount, mobileMax, desktopMax) {
  const paginationRoot = swiper.pagination?.el?.closest('.adagio-swiper-pagination')
  if (!paginationRoot) {
    return
  }

  const max = window.innerWidth >= DESKTOP_MIN ? desktopMax : mobileMax
  paginationRoot.classList.toggle('is-hidden', slideCount <= max)
}

/**
 * Init one magazine slider with the shared Swiper helper.
 * Dots stay hidden while there are not enough real slides, matching the old thresholds.
 */
export function renderMagazineSwiper(root, {
  containerSelector,
  theme = 'white',
  skipNavigation = false,
  mobileMax = 1,
  desktopMax = 1,
  overrides = {},
} = {}) {
  const element = root?.nodeType === 1 ? root : root?.[0]
  if (!element) {
    return null
  }

  const container = element.querySelector(containerSelector)
  if (!container) {
    return null
  }

  const slideCount = countSlides(container)
  if (!slideCount) {
    return null
  }

  const slidesPerView = overrides.slidesPerView
  const canLoop = Boolean(overrides.loop)
    && typeof slidesPerView === 'number'
    && slideCount > slidesPerView

  return initSwiper(element, {
    preset: 'default',
    containerSelector,
    theme,
    skipNavigation,
    overrides: {
      spaceBetween: 0,
      speed: 300,
      threshold: 15,
      ...overrides,
      loop: canLoop,
    },
    onInit(swiper) {
      const update = () => syncPagination(swiper, slideCount, mobileMax, desktopMax)
      update()
      swiper.on('resize', update)
      swiper.on('breakpoint', update)
    },
  })
}
